// extracted by mini-css-extract-plugin
module.exports = {"flex":"style__flex__GegBA","siteLabel":"style__siteLabel__7QWRf","modalFooter":"style__modalFooter__ZM8Fp","siteNameLabel":"style__siteNameLabel__f1jLW"};